import { FC, ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useAppDispatch } from 'app/hooks';

import { deselected,selected } from './adminMenuSlice';

type Props = {
  to: string;
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: ReactElement<any>;
  isChild?: boolean;
  buttonSx: SxProps<Theme>;
};

const NavbarButton: FC<Props> = ({
    to,
    text,
    icon,
    isChild,
    buttonSx
}) => {
    const dispatch = useAppDispatch();
    return (
        <ListItemButton
            component={NavLink}
            to={to}
            sx={buttonSx}
            onClick={() => dispatch(isChild ? selected() : deselected() )}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
        </ListItemButton>
    );
};

export { NavbarButton };
